document.addEventListener('DOMContentLoaded', function() {
    const recoverEmailInput = document.getElementById('recover-email');
    const recoverPasswordButton = document.getElementById('recover-password-btn');
    const formMessage = document.getElementById('form-message'); // Reusing the form message area

    recoverPasswordButton.addEventListener('click', function(event) {
        event.preventDefault();

        // Gather input data
        const recoverEmail = document.getElementById('recover-email').value.trim();

        // Validate input field
        if (!recoverEmail) {
            formMessage.innerText = 'Prosím vyplňte email.';
            return;
        }

        // Add loading state to the button
        recoverPasswordButton.innerHTML = 'Odesílám...';

        // Create JSON object
        const data = {
            email: recoverEmail
        };

        // Send the request via Fetch API
        fetch('/apps/api/customerrecoverpass', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            if (response.ok) {
                return response.json(); // Parse JSON response if needed
            } else {
                throw new Error('Network response was not ok');
            }
        })
        .then(data => {
            // Remove loading state
            recoverPasswordButton.innerHTML = 'Odesláno na tvůj email!';
            recoverEmailInput.classList.add('disabled');
            recoverPasswordButton.style.pointerEvents = "none";

            // Check the response status
            if (data.status === 'success') {
                formMessage.innerText = 'Odkaz pro obnovu tvého hesla jsme ti poslali na email!';
            } else {
                formMessage.innerText = 'Něco se pokazilo, zkus to později znovu.';
                formMessage.style.color = 'red';
            }
        })
        .catch(error => {
            // Handle error
            console.error('Error:', error);
            formMessage.innerText = 'Něco se pokazilo, zkus to později znovu.';
            formMessage.style.color = 'red';

            // Remove loading state
            recoverPasswordButton.innerHTML = 'Obnovit heslo';
        });
    });
});
